<template>
  <div class="vue-outer-wrap homepage">
    <div v-if="readyToRenderPage" class="inner-wrap">
      <mobile-home v-if="isMobile() || this.isTablet()"></mobile-home>
      <desktop-home v-if="!isMobile() && !this.isTablet()"></desktop-home>
    </div>
  </div>
</template>

<script>
import MobileHome from "../components/mobile/MobileHome";
import DesktopHome from "../components/desktop/DesktopHome";
import vueMqMixin from "../components/shared/mixins/VueMqMixin";

export default {
  name: 'HomePage',
  mixins: [vueMqMixin],
  created() {
    // if browser is ie-11, do not proceed
    if (window.vtOutagesIsIe11){return; }
    setTimeout(() => this.readyToRenderPage = true, 50)
  },
  components: {DesktopHome, MobileHome},
  data() {
    return {
      readyToRenderPage: undefined
    }
  },
  metaInfo: {
    title: "VTOutages",
    meta: [
      {
        name: "description",
        content:
          "VTOutages is Vermont's official outage resource."
      }
    ]
  }
};
</script>
